import React from "react";
import { useErrorHandler } from "react-error-boundary";
import { RouteComponentProps } from "@reach/router";
import { useProducerTransactionsQuery } from "@apollo/ops";
import { LoadingIcon } from "@components/ui/Spinner";
import { Page, PageHeading } from "@components/ui/Page";
import { ProducerTransactionsTable } from "./ProducerTransactionsTable";
import { ProducerBalance } from "./ProducerBalance";

type ProducerProps = {
  businessEntityId: number;
} & RouteComponentProps;

export function ProducerTransactions({ businessEntityId }: ProducerProps) {
  const { data: results, loading, error } = useProducerTransactionsQuery({
    variables: {
      businessId: businessEntityId,
    },
  });

  useErrorHandler(error);

  const data = results?.business?.fundsTransfers
    ? results.business.fundsTransfers
    : [];

  return (
    <Page heading={<PageHeading title="Your Transactions" />}>
      <ProducerBalance businessId={businessEntityId} />
      <div className="mt-10">
        {loading ? (
          <LoadingIcon />
        ) : (
          <div className="mt-8 card">
            {!loading && (!data || data.length === 0) ? (
              <>
                <p>No transactions</p>
                <br />
              </>
            ) : null}

            {data.length > 0 && (
              <ProducerTransactionsTable fundsTransfers={data} />
            )}
          </div>
        )}
      </div>
    </Page>
  );
}
